import { PromoBenefitsSection } from '@/pages/promotion/components/promo-benefits-section'
import { PromoHowToSection } from '@/pages/promotion/components/promo-how-to-section'
import { PromoOffersSection } from '@/pages/promotion/components/promo-offers-section'
import { PromoPageHeader } from '@/pages/promotion/components/promo-page-header'
import { PromoSupportSection } from '@/pages/promotion/components/promo-support-section'

export const August2025PromoRoute = () => {
  return (
    <div className="flex flex-col gap-24">
      <section className="flex flex-col gap-8">
        <PromoPageHeader />
        <PromoBenefitsSection />
      </section>
      <PromoOffersSection />
      <PromoSupportSection />
      <PromoHowToSection />
    </div>
  )
}
